<template>
    <header class="header" :data-header-type="headerType === 'shop' ? 'shop' : ''">
        <!-- PC 헤더 -->
        <div class="header-primary-container">
            <!--
                ※ 헤더 타입:
                쇼핑몰
            -->
            <div v-if="headerType === 'shop'" class="header-primary">
                <div class="header-primary__contents">
                    <div class="header-primary__forward">
                        <!-- 모바일 사이드바 토글 버튼 -->
                        <div class="mobile-menu">
                            <button type="button" aria-pressed="false" class="button">
                                <span></span>
                            </button>
                        </div>
                    </div>
                    <div class="header-primary__left">
                        <div class="header-logo">
                            <h1>
                                <router-link to="/shop" title="스토어 홈으로 이동">
                                    <span class="blind">새집처럼 스토어</span>
                                </router-link>
                            </h1>
                        </div>
                        <div class="header-search">
                            <form class="header-search__form">
                                <input v-model="searchValue" class="header-search__input" type="text" name="" value="" placeholder="검색어를 입력하세요" />
                                <button class="header-search__button" @click="search"></button>
                            </form>
                        </div>
                    </div>
                    <div class="header-primary__main">
                        <ul class="header-customer-lists">
                            <li><a href="/center/faq">고객센터</a></li>
                            <li v-if="!accessToken">
                                <router-link to="/login"><span>로그인</span></router-link>
                            </li>
                            <li v-if="accessToken">
                                <router-link to="" @click.native="logout"><span>로그아웃</span></router-link>
                            </li>
                            <li v-if="!accessToken">
                                <router-link to="/join/type"><span>회원가입</span></router-link>
                            </li>
                            <li v-if="accessToken">
                                <router-link to="/mypage/myinfo" @click.native="setHeaderType('shop')"><span>마이페이지</span></router-link>
                            </li>
                            <li v-if="showConsole">
                                <a href="/console" target="blank"><span style="color:#000">관리자페이지</span></a>
                            </li>
                        </ul>
                        <ul class="header-menu-lists">
                            <!-- <li class="header-menu-list"> -->
                            <!--
                                    ※1뎁스 활성화시 a.link에 서브 클래스 추가
                                    서브 클래스명: link--on
                                 -->
                            <!-- <a class="link" href="#" @click="$router.push(urlPortfolio('주거공간'))"><h2>주거공간</h2></a>
                                <ul class="header-menu-sub"> -->
                            <!--
                                *2뎁스 활성화시 서브클래스 추가
                                서브클래스명: sub-link--on
                                 -->
                            <!-- <li><a class="sub-link" href="#" @click="$router.push(urlPortfolio('주거공간'))">주거유형별 인테리어</a></li>
                                    <li><a class="sub-link" href="#" @click="$router.push('/portfolio/list/space')">공간별 인테리어</a></li>
                                </ul>
                            </li> -->
                            <li class="header-menu-list">
                                <router-link to="/shop/categories" class="link"><h2>카테고리</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/shop/best" class="link"><h2>베스트</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/shop/hot" class="link"><h2>핫딜</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/shop/event" class="link"><h2>이벤트</h2></router-link>
                            </li>
                            <li class="header-menu-list" v-show="false">
                                <router-link to="/shop/exhibition" class="link"><h2>기획전</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/" @click.native="setHeaderType('normal')" class="link link--line"><h2>새집처럼</h2></router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="header-primary__right">
                        <router-link to="/mypage/cart" class="header-primary__right-cart" style="display:flex;align-items:center;justify-content:center;width:130px;height:100%;margin:0 0 0 40px;padding:10px;background:#30cd84;color:#fff;"><span class="blind">장바구니</span>장바구니</router-link>
                    </div>
                </div>
            </div>

            <!--
                ※ 헤더 타입:
                일반
            -->
            <div v-else class="header-primary">
                <div class="header-primary__contents">
                    <div class="header-primary__forward">
                        <!-- 모바일 사이드바 토글 버튼 -->
                        <div class="mobile-menu">
                            <button type="button" aria-pressed="false" class="button">
                                <span></span>
                            </button>
                        </div>
                    </div>
                    <div class="header-primary__left">
                        <div class="header-logo">
                            <h1>
                                <router-link to="/" title="홈으로 이동">
                                    <span class="blind">새집처럼</span>
                                </router-link>
                            </h1>
                        </div>
                        <div class="header-search">
                            <form class="header-search__form">
                                <input v-model="searchValue" class="header-search__input" type="text" name="" value="" placeholder="검색어를 입력하세요" />
                                <button class="header-search__button" @click="search"></button>
                            </form>
                        </div>
                    </div>
                    <div class="header-primary__main">
                        <ul class="header-customer-lists">
                            <li v-if="!accessToken">
                                <router-link to="/login"><span>로그인</span></router-link>
                            </li>
                            <li v-if="accessToken">
                                <router-link to="" @click.native="logout"><span>로그아웃</span></router-link>
                            </li>
                            <li v-if="!accessToken">
                                <router-link to="/join/type"><span>회원가입</span></router-link>
                            </li>
                            <li v-if="accessToken">
                                <router-link to="/mypage/myinfo" @click.native="setHeaderType('normal')"><span>마이페이지</span></router-link>
                            </li>
                            <li v-if="showConsole">
                                <a href="/console" target="blank"><span style="color:#000">관리자페이지</span></a>
                            </li>
                            <li><a href="/center/faq">고객센터</a></li>
                        </ul>
                        <ul class="header-menu-lists">
                            <li class="header-menu-list">
                                <!--
                                    ※1뎁스 활성화시 a.link에 서브 클래스 추가
                                    서브 클래스명: link--on
                                 -->
                                <router-link to="/portfolio/resident" class="link"><h2>주거공간</h2></router-link>
                                <ul class="header-menu-sub">
                                    <!--
                                    *2뎁스 활성화시 서브클래스 추가
                                    서브클래스명: sub-link--on
                                 -->
                                    <li><router-link to="/portfolio/resident" class="sub-link">주거유형별 인테리어</router-link></li>
                                    <li><router-link to="/portfolio/space" class="sub-link">공간별 인테리어</router-link></li>
                                </ul>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/portfolio/industry" class="link"><h2>상업공간</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/portfolio/partial" class="link"><h2>부분시공</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/partners/reassurance" class="link"><h2>파트너스</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/community/house" class="link"><h2>커뮤니티</h2></router-link>
                            </li>
                            <li class="header-menu-list">
                                <router-link to="/shop" @click.native="setHeaderType('shop')" class="link link--line"><h2>스토어</h2></router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="header-primary__right">
                        <router-link to="/estimate/estimate-inquiry" class="header-primary__right-inquiry"><span class="blind">견적신청 1566-7777</span></router-link>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="headerType === 'shop' && headerSecondary === 'on'" class="header-secondary-container">
            <div class="header-secondary">
                <nav class="header-secondary__contents">
                    <router-link :class="$route.path === '/shop/categories' ? 'on item' : 'item'" to="/shop/categories">카테고리</router-link>
                    <router-link :class="$route.path === '/shop/best' ? 'on item' : 'item'" to="/shop/best">베스트</router-link>
                    <router-link :class="$route.path === '/shop/hot' ? 'on item' : 'item'" to="/shop/hot">핫딜</router-link>
                    <router-link :class="$route.path === '/shop/event' ? 'on item' : 'item'" to="/shop/event">이벤트</router-link>
                    <router-link :class="$route.path === '/shop/exhibition' ? 'on item' : 'item'" to="/shop/exhibition">기획전</router-link>
                </nav>
            </div>
        </div>

        <!--
            ※모바일 사이드바 타입:
            쇼핑몰
        -->
        <div v-if="headerType === 'shop'" class="mobile-sidebar">
            <div class="mobile-sidebar__head">
                <button class="mobile-sidebar__close" type="button"><span class="blind">모바일 메뉴바 닫기</span></button>
                <div class="mobile-sidebar-info">
                    <a class="member-name" href="/login">
                        <span v-if="!accessToken">로그인 해주세요</span>
                        <span v-if="accessToken"></span>
                    </a>
                </div>
            </div>
            <div class="mobile-sidebar__body">
                <ul class="mobile-category__lists">
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/" onclick="event.preventDefault()">새집처럼 메인</router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <a class="mobile-category__list-link" data-toggle="closed">
                            <i class="arrow"></i>
                            <span>카테고리</span>
                        </a>
                        <header-shop-categories />
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/shop/best" onclick="event.preventDefault()">베스트</router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/shop/hot" onclick="event.preventDefault()">핫딜</router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/shop/event" onclick="event.preventDefault()">이벤트</router-link>
                    </li>
                    <!-- <li class="mobile-category__list" data-category-order>
                        <a class="mobile-category__list-link" href="#" @click="$router.push('/shop/exhibition')" onclick="event.preventDefault()">기획전</a>
                    </li> -->
                </ul>
                <ul class="mobile-usermenu__lists">
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="/mypage/myinfo">마이페이지</router-link></li>
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="/center/terms">이용약관</router-link></li>
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="/center/privacy-policy">개인정보처리방침</router-link></li>
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="">이메일 무단수집 거부</router-link></li>
                </ul>
            </div>
            <!-- <div class="mobile-sidebar__foot">
                <ul class="mobile-foot-link">
                    <li><a href="/center/terms">이용약관</a></li>
                    <li><a href="/center/privacy-policy">개인정보처리방침</a></li>
                    <li><a href="">제휴요청</a></li>
                </ul>
            </div> -->
        </div>

        <!--
            ※모바일 사이드바 타입:
            일반
        -->
        <div v-else class="mobile-sidebar">
            <div class="mobile-sidebar__head">
                <button class="mobile-sidebar__close" type="button"><span class="blind">모바일 메뉴바 닫기</span></button>
                <div class="mobile-sidebar-info">
                    <router-link class="member-name" to="/login">
                        <span v-if="!accessToken">로그인 해주세요</span>
                        <span v-if="accessToken"></span>
                    </router-link>
                </div>
            </div>
            <div class="mobile-sidebar__body">
                <ul class="mobile-category__lists">
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/shop" onclick="preventDefault();"><span class="color">새집처럼 스토어</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <a class="mobile-category__list-link" data-toggle="closed">
                            <i class="arrow"></i>
                            <span>주거공간</span>
                        </a>
                        <ul class="mobile-category__level mobile-category__level--1">
                            <li>
                                <router-link class="mobile-category__level-link" to="/portfolio/resident"><span>주거유형별 인테리어</span></router-link>
                            </li>
                            <li>
                                <router-link class="mobile-category__level-link" to="/portfolio/space"><span>공간별 인테리어</span></router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <a class="mobile-category__list-link" href="/portfolio/industry">
                            <i class="arrow"></i>
                            <span>상업공간</span>
                        </a>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/portfolio/partial"><span>부분시공</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/partners/reassurance"><span>파트너스</span></router-link>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <router-link class="mobile-category__list-link" to="/community/house"><span>커뮤니티</span></router-link>
                    </li>
                </ul>
                <ul class="mobile-usermenu__lists">
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="/mypage/myinfo">마이페이지</router-link></li>
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="/center/terms">이용약관</router-link></li>
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="/center/privacy-policy">개인정보처리방침</router-link></li>
                    <li class="mobile-usermenu__list"><router-link class="mobile-usermenu__list-link" to="">이메일 무단수집 거부</router-link></li>
                </ul>
            </div>
            <!-- <div class="mobile-sidebar__foot">
                <ul class="mobile-foot-link">
                    <li><a href="/center/terms">이용약관</a></li>
                    <li><a href="/center/privacy-policy">개인정보처리방침</a></li>
                    <li><a href="">제휴요청</a></li>
                </ul>
            </div> -->
        </div>
        <div class="mobile-sidebar-dimmed"></div>
    </header>
</template>

<script>
import { Header } from "@/plugins/header.js"; // Sticky & 모바일메뉴 스크립트
import HeaderShopCategories from "./header-shop-categories.vue";
export default {
    components: { HeaderShopCategories },
    props: {
        headerType: { type: String, default: "normal" },
        headerSecondary: { type: String, default: "on" },
    },
    data() {
        return {
            loading: false,
            setheaderType: { type: String, default: "normal" },
            searchValue: "",
        };
    },
    mounted() {
        this.header();
        this.getSearchQuery();
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작
    },
    methods: {
        getSearchQuery() {
            const { path, query } = this.$router.currentRoute;
            if (path.includes("search")) this.searchValue = query?.q || "";
        },
        logout() {
            if (confirm("로그아웃 하시겠습니까?")) {
                this.$store.dispatch("logout");
            }
        },
        header: function() {
            this.$nextTick(function() {
                Header(); // Sticky & 모바일메뉴 스크립트 로드
            });
        },
        setHeaderType(headerType) {
            // 사이트 헤더 타입 설정(기본타입 or 스토어타입)
            this.setheaderType = headerType;

            const BODY = document.querySelector("body");

            BODY.setAttribute("data-header-type", this.setheaderType);
        },
        search(event) {
            event.preventDefault();

            const { path, query } = this.$router.currentRoute;
            if (!(path.includes("search") && query?.q === this.searchValue)) {
                if (this.headerType == "normal") {
                    if (path.includes("search")) {
                        this.$router.push({ query: { q: this.searchValue } });
                    } else this.$router.push(`/search/all?q=${this.searchValue}`);
                } else this.$router.push(`/search/store?q=${this.searchValue}`);
                this.$emit("search", this.searchValue);
            }
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        payload() {
            return this.$store.state.payload;
        },
        showConsole() {
            return (this?.$store?.state?.payload?.scope || []).some((scope) => ["console", "interior", "store", "measurer", "company", "technician"].includes(scope));
        },
    },
};
</script>
